import React from 'react';
import { CheckCheck } from 'lucide-react';
import styles from './SimpleToast.module.css';

// Small bottom-center pill toast — the pattern Dashboard/EventsPage/
// TransferHistoryPage each used to reimplement independently. Purely
// presentational; pair with the useToast hook for auto-dismiss timing.
export default function SimpleToast({ message }) {
    return <div className={styles.toast}><CheckCheck size={14} />{message}</div>;
}
